import * as CONFIG from "../_config";

export const setCSS = (string) => {
  let salt = new Date().getTime();

  if (CONFIG.DATA.THEME === 2) {
    var head = document.getElementsByTagName("HEAD")[0];
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = "/assets/css/theme2.css?" + salt;
    head.appendChild(link);
  }

  if (CONFIG.DATA.BASIC_THEME === true) {
    var head = document.getElementsByTagName("HEAD")[0];
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = "/assets/css/theme_basic.css?" + salt;
    head.appendChild(link);
  }

  if (CONFIG.DATA.ONLY_COUPONS === true) {
    var head = document.getElementsByTagName("HEAD")[0];
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = "/assets/css/theme_coupons.css?" + salt;
    head.appendChild(link);
  }

  if (CONFIG.DATA.HAS_CUSTOM_CSS === true) {
    var head = document.getElementsByTagName("HEAD")[0];
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = "/assets/sites/" + CONFIG.DATA.BACKEND_HOST + ".css?" + salt;
    head.appendChild(link);
  }

  if (CONFIG.DATA.BACKEND_HOST === "dicksfreshmarket") {
    var link = document.createElement("meta");
    link.setAttribute("name", "facebook-domain-verification");
    link.content = "hl6enm7e7nrs9s3i4r1oxj1esitcaa";
    document.getElementsByTagName("HEAD")[0].appendChild(link);
  }
  // if (CONFIG.DATA.FB_DOMAIN_VERIFICATION_CODE !== "") {
  //   var link = document.createElement("meta");
  //   link.setAttribute("name", "facebook-domain-verification");
  //   link.content = CONFIG.DATA.FB_DOMAIN_VERIFICATION_CODE;
  //   document.getElementsByTagName("HEAD")[0].appendChild(link);
  // }
};

// For CSS properties (background, background-image)
export function sanitizeUrlForCSS(url) {
  let sanitizedUrl = url
  try {
    sanitizedUrl = replaceUrl(url)
    sanitizedUrl = Isfullurl(sanitizedUrl)
    
    if (sanitizedUrl.startsWith('#') || sanitizedUrl.startsWith('rgb') || sanitizedUrl.startsWith('hsl')) {
      return sanitizedUrl
    } else {
      return `url('${sanitizedUrl}')`
    }
  } catch (error) {
    console.log('🚀 ERROR >>> ', error)
    return url
  }
}

// For HTML attributes (src, href)
export function sanitizeUrlForHtml(url) {
  let sanitizedUrl = url
  try {
    sanitizedUrl = replaceUrl(url)
    sanitizedUrl = Isfullurl(sanitizedUrl)
    return sanitizedUrl // Return plain URL
  } catch (error) {
    console.log('🚀 ERROR >>> ', error)
    return url
  }
}

export const replaceUrl = (url = "") => {
  return url
    ?.replace("url(", "")
    ?.replace(/'/g, "")
    ?.replace(/"/g, "")
    ?.replace(")", "");
};

export const Isfullurl = (url = "") => {
  try {
    let domain_name = window.location.protocol + "//" + window.location.hostname;
    const regexp =
      /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (regexp.test(url)) return url;
    else return domain_name + url;
  } catch (error) {
    console.log('🚀 ERROR >>> ', error)
    return url
  }
};